import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { actions } from '../../actions/app';
import { track } from '../../utils/track';
import { lifecycle } from './actions';
import { selector } from './selector';
import LoginAndPassword from './components/LoginAndPassword';
import Code from './components/Code';

const dispatchProps = {
  selectResetPasswordTab: () => actions.showAuthModal('restore'),
};

export interface Props {}

type Enhanced = Props & ReturnType<typeof selector> & typeof dispatchProps;

const enhance = compose<Enhanced, Props>(
  track({ activate: lifecycle.activate }),
  connect(selector, dispatchProps)
);

class SignIn extends React.Component<Enhanced> {
  render() {
    const { stage, selectResetPasswordTab, secondFactor } = this.props;

    if (stage === 'loginAndPassword') {
      return <LoginAndPassword selectResetPasswordTab={selectResetPasswordTab} />;
    }

    if (secondFactor) {
      return <Code codeSource={secondFactor.codeSource} />;
    }

    return null;
  }
}

export default enhance(SignIn);
